const programNotices = state => state.programNotices;
const programNoticesLoaded = state => state.programNoticesLoaded;
const organizationNotice = state => state.organizationNotice;
const organizationNoticeLoaded = state => state.organizationNoticeLoaded;

export default {
  programNotices,
  programNoticesLoaded,
  organizationNotice,
  organizationNoticeLoaded
};
